import NextImage from 'next/image';

import type { ImageProps as NextImageProps } from 'next/image';
import type { FC } from 'react';

export interface ImageProps extends Omit<NextImageProps, 'src' | 'alt'> {
  /**
   * The `url` prop represents the URL of the image to be displayed.
   */
  url?: string;
  /**
   * The `alt` prop represents the alternative text for the image. This text is used to describe the image for accessibility purposes, such as for screen readers. If no `alt` text is provided, the image may not be accessible to users with disabilities.
   */
  alt?: Maybe<string>;
}

const Image: FC<ImageProps> = ({ alt, className, height, width, url = null, ...props }) => {
  if (!url) {
    console.warn(`Image with alt: ${alt} is ${url}`);

    return null;
  }

  return (
    <NextImage
      src={url}
      alt={alt || ''}
      title={alt || ''}
      width={width || 0}
      height={height || 0}
      className={className}
      {...props}
    />
  );
};

export default Image;
